export const ULSubmitToAuthorityMilestone = 'UL: Submit to Authority/Authority Review'
